/**
 * Toolbox Atoms -- Jotai state for right-side toolbox panel
 *
 * Active panel and panel width are React-internal UI state (Jotai).
 * Expand/collapse state lives in bridge state (ui.toolboxExpanded)
 * so both React and Slate can read it.
 */

import { atom } from 'jotai'

/** Currently active panel ID (e.g. 'ai-chat', 'history', 'tags') */
export const toolboxActivePanelAtom = atom<string | null>(null)

/** Toolbox content panel width in pixels */
export const toolboxPanelWidthAtom = atom(320)
